import React from "react";
import "./Cars.scss";

import car_blue from "../../assets/cars/car_blue.png"
import car_green from "../../assets/cars/car_green.png"
import car_red from "../../assets/cars/car_red.png"
import car_white from "../../assets/cars/car_white.png"





function Cars() {
  return (
    <>
     <img className="car_blue" src={car_blue} alt="" /> 
     <img className="car_red" src={car_red} alt="" />
     <img className="car_green" src={car_green} alt="" />
     <img className="car_white" src={car_white} alt="" />
    </>
  );
}

export default Cars;
